export default {
    devicemodel_tab_name: "Nombre",
    devicemodel_tab_product: "Producto",
    devicemodel_tab_inputs: "Entradas",
    devicemodel_tab_outputs: "Salidas",
    devicemodel_tab_status: "Estado",
    devicemodel_tab_add_new: "Agregar Nuevo",
    devicemodel_tab_unit_type: "Tipo de Unidad",
    devicemodel_tab_support_geofences: "Soporta Geocercas",
    devicemodel_tab_geofence_type: "Tipo de Geocerca",
    devicemodel_tab_geofence_polygon: "Poligono",
    devicemodel_tab_geofence_regular_shape: "Forma Regular",
    devicemodel_tab_geofence_both: "Ambos",
    devicemodel_tab_bulk_assign_alert_types: "Asignación masiva de tipos de alerta",
}